import { GetPastelCustomerByAccountQuery,  PastelCustomerDetailModel, PastelCustomerModel, PreRegisterResultModel, PreRegisterUserCommand, RegisterExternalUserCommand, UserModel } from "@core/services/api.service";

export class LoadCustomerInfoAction {
  static readonly type = '[Customer Info] Load Customer Info';

  //constructor(public payload: { loadCustomerAccountDetails: GetPastelCustomerDetailsByAccountIdQuery }) { }
}

export class LoadCustomerInfoSuccessAction {
  static readonly type = '[Customer Info] Load Customer Info Success';

  constructor(public payload: { customerInfo: PastelCustomerModel }) { }
}

export class LoadCustomerInfoFailAction {
  static readonly type = '[Customer Info] Load Customer Info Fail';

  constructor(public payload: { response: string }) {}
}

//Load Customer OTP Details

export class LoadPastelCustomerByAccountAction {
    static readonly type = '[Customer Account] Load Customer Account';
  
    constructor(public payload: { loadPastelCustomerByAccountQuery: GetPastelCustomerByAccountQuery }) { }
  }
  
  export class LoadPastelCustomerByAccountSuccessAction {
    static readonly type = '[Customer Account] Load Customer Account Success';
  
    constructor(public payload: { pastelCustomerDetail: PastelCustomerDetailModel }) { }
  }
  
  export class LoadPastelCustomerByAccountFailAction {
    static readonly type = '[Customer Account] Load Customer Account Fail';

    constructor(public payload: { response: string }) {}
  }

  // Request Otp

  export class RequestOtpAction {
    static readonly type = '[Request Otp] Request OTP';
  
    constructor(public payload: { preRegisterUserCommand: PreRegisterUserCommand }) { }
  }
  
  export class RequestOtpSuccessAction {
    static readonly type = '[Request Otp] Request OTP Success';
  
    constructor(public payload: { preRegisterResultModel: PreRegisterResultModel }) { }
  }
  
  export class RequestOtpFailAction {
    static readonly type = '[Request Otp] Request OTP Fail';
    
    constructor(public payload: { response: string }) {}
  }



  // Register

  export class RegisterAction {
    static readonly type = '[Register Account] Register';
  
    constructor(public payload: { registerExternalUserCommand: RegisterExternalUserCommand }) { }
  }
  
  export class RegisterSuccessAction {
    static readonly type = '[Register Account] Register Success';
  
    constructor(public payload: { account: UserModel, registerExternalUserCommand: RegisterExternalUserCommand}) { }
  }
  
  export class RegisterFailAction {
    static readonly type = '[Register Account] Register Fail';
    
    constructor(public payload: { response: string }) {}
  }